"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownExperimentalLayout = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../../button");

var _dropdownList = require("../../../helpers/dropdown-list");

var _layout = require("../../../layout");

var _popover = require("../../../popover");

var _utils = require("../../../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownExperimentalLayout = function DropdownExperimentalLayout(_ref) {
  var clearButtonRef = _ref.clearButtonRef,
      _ref$clearButtonText = _ref.clearButtonText,
      clearButtonText = _ref$clearButtonText === void 0 ? _constants.dropdownExperimentalLayoutDefaultProps.clearButtonText : _ref$clearButtonText,
      closeMenu = _ref.closeMenu,
      dropdownListComponent = _ref.dropdownListComponent,
      dropdownTriggerProps = _ref.dropdownTriggerProps,
      getLabelProps = _ref.getLabelProps,
      getMenuProps = _ref.getMenuProps,
      handleClear = _ref.handleClear,
      handleHighlightLastItem = _ref.handleHighlightLastItem,
      isOpen = _ref.isOpen,
      isMulti = _ref.isMulti,
      labelIdProp = _ref.labelId,
      labelText = _ref.labelText,
      popoverControllerProps = _ref.popoverControllerProps,
      showClearButton = _ref.showClearButton,
      triggerButtonProps = _ref.triggerButtonProps,
      triggerContent = _ref.triggerContent,
      triggerRef = _ref.triggerRef,
      width = _ref.width;
  var shouldCloseMenuRef = (0, _react.useRef)(true); // Adds a gap between popover and window's bottom position

  var popoverContentMaxHeight = 'calc(100vh - 90px)';
  var labelId = labelIdProp || getLabelProps().id;
  var describedById = labelId ? "".concat(labelId, "-trigger") : undefined;

  var handleBlur = function handleBlur() {
    if (shouldCloseMenuRef.current) {
      closeMenu();
    } else {
      shouldCloseMenuRef.current = true;
    }
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === _utils.EventKeys.ESCAPE) {
      closeMenu();
    } else if (e.key === _utils.EventKeys.ARROW_UP) {
      // Make the button blur but don't close the menu
      shouldCloseMenuRef.current = false;
      handleHighlightLastItem();
    }
  };

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("span", {
    id: labelId,
    hidden: true
  }, labelText), (0, _core.jsx)(_dropdownList.DropdownTrigger, (0, _extends2.default)({}, dropdownTriggerProps, triggerButtonProps, {
    "aria-labelledby": labelId,
    "aria-describedby": describedById,
    shouldUseStencilButton: true
  }), (0, _core.jsx)("span", {
    id: describedById
  }, triggerContent)), !isOpen && (0, _core.jsx)("ul", (0, _extends2.default)({}, getMenuProps({}, {
    suppressRefError: true
  }), {
    role: "listbox",
    "aria-multiselectable": isMulti ? 'true' : undefined,
    "aria-hidden": isOpen ? 'false' : 'true',
    style: {
      margin: 0
    }
  })), (0, _core.jsx)(_popover.PopoverController, (0, _extends2.default)({}, popoverControllerProps, {
    close: function close() {
      return null;
    },
    isOpen: isOpen,
    target: triggerRef
  }), (0, _core.jsx)(_layout.Col, {
    maxHeight: popoverContentMaxHeight,
    minWidth: width
  }, dropdownListComponent, showClearButton && (0, _core.jsx)(_helperComponents.DropdownExperimentalLayoutFooterRow, null, (0, _core.jsx)(_button.Button, {
    "aria-describedby": triggerContent === labelText ? labelId : "".concat(labelId, " ").concat(describedById),
    "aria-hidden": false,
    onBlur: handleBlur,
    onClick: handleClear,
    onKeyDown: handleKeyPress,
    ref: clearButtonRef,
    size: _button.ButtonSize.Small,
    tabIndex: 0,
    variant: _button.ButtonVariant.Tertiary
  }, clearButtonText)))));
};

exports.DropdownExperimentalLayout = DropdownExperimentalLayout;